<div
  class="fieldset-wrapper multiple-dropdown"
  style="overflow: visible"
  id="Q{{ imgQuestion?.qno }}_{{ imgQuestion?.UniqueNumber }}_RW"
>
  <div
    *ngIf="imgQuestion?.QuestionImageAndMedia_1 != null"
    class="questionImageWrapper"
    [ngClass]="{ 'question-border': !isMobile }"
  >
    <app-question-image-and-media
      [questionImageAndMedias]="imgQuestion?.QuestionImageAndMedia_1"
      [imageSize]="imgQuestion?.ImageSize"
      [isMobile]="isMobile"
    >
    </app-question-image-and-media>
  </div>

  <fieldset>
    <legend
      class="question-option-wrapper"
      [ngClass]="{ 'question-border': imgQuestion?.QuestionImageAndMedia_1 == null && !isMobile }"
    >
      <span *ngIf="isDisplayQno" class="question-no"><strong>{{ imgQuestion.qno }}.</strong></span>
      <span
        [ngClass]="group?.isOverAllStyleApplied ? 'question-text' : 'question-text-nb'"
        [ngClass]="{
          'question-text': group?.isOverAllStyleApplied,
          'question-text-nb': !group?.isOverAllStyleApplied,
          'no-Qno': !isDisplayQno
        }"
        id="lbltitle_RW{{ imgQuestion?.UniqueNumber }}"
      >
        <span
          *ngIf="questions[0].piping"
          [innerHTML]="getPipingTitle(questions[0]?.group_no) | headerFooterHtml"
        ></span>
        <span *ngIf="!questions[0].piping" [innerHTML]="group?.gtitle | headerFooterHtml"></span>
        <span
          *ngIf="group?.QuestionTip"
          class="tooltip_icon"
          appTooltip
          [dataContext]="group?.QuestionTip"
          [IsButtonPanel]="false"
          [qid]="imgQuestion?.UniqueNumber"
          tabindex="0"
        ></span>                  
        <div
          *ngIf="
            imgQuestion?.hasMedia && imgQuestion?.MediaText != null && imgQuestion?.MediaText != ''
          "
          class="question-media-text"
        >
          <span>[{{ imgQuestion?.MediaText }}]</span>
        </div>
      </span>
    </legend>

    <div *ngIf="imgQuestion?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
      <app-question-image-and-media
        [questionImageAndMedias]="imgQuestion?.QuestionImageAndMedia_2"
        [imageSize]="imgQuestion?.ImageSize"
        [isMobile]="isMobile"
      >
      </app-question-image-and-media>
    </div>

    <div class="answer-option-wrapper drill-box" 
    [ngClass]= "{'isHiddenQtype': isShowHiddenQN}">
      <table class="drill-down-wrapper" *ngIf="!isMobile" role="presentation">
        <tr
          class="drill-down-subqtn"
          *ngFor="let question of questions; let i = index"
          [ngStyle]="{
            display: question.population_type == 2 && !isShowHiddenQN? 'none' : ''
          }"
        >
          <td>
            <div *ngIf="GetSelectedAnswer(i, question) != null">
              <span
                *ngIf="
                  question.piping &&
                  (question?.pipingQuationTitle != '' || isDisplayQno || question?.mandatory)
                "
                [ngClass]="{
                  'question-text': question?.isOverAllStyleApplied,
                  'question-text-nb': !question?.isOverAllStyleApplied,
                  'no-Qno': !isDisplayQno,
                  'drill-subq-read-only': question?.population_type == 3
                }"
                id="lbltitle_L{{ question?.UniqueNumber }}"
              >
                <span
                  *ngIf="isDisplayQno"
                  class="question-no"
                  style="display: inline-block"
                  [innerHTML]="question?.subQnoinChar | headerFooterHtml"
                ></span>
                <span [innerHTML]="question?.pipingQuationTitle | headerFooterHtml"></span>
                <span
                  *ngIf="question.QuestionTip"
                  class="tooltip_icon"
                  appTooltip
                  [dataContext]="question?.QuestionTip"
                  [IsButtonPanel]="false"
                  [qid]="question?.UniqueNumber"
                  tabindex="0"
                ></span>
                <span class="imgPostPrepop" 
            *ngIf="isEditPostPop == true && (question?.population_type== 4 || question?.population_type == 5)"></span>
              </span>
            </div>
          </td>
          <td>
            <div
              *ngIf="GetSelectedAnswer(i, question) != null"
              [ngClass]="
                (question?.mandatory && (isMandatoryUpfront || question?.isMandatoryStar)) ||
                (question?.mandatory && isFormSubmit && question.isMandatoryInvalid)
                  ? 'isMandatory'
                  : ''
              "
            >
              <span
                *ngIf="
                  isPreview &&
                  (questions[i].population_type == 2 || questions[i].population_type == 5) &&
                  questions[i] == question
                "
                class="hidden-question-tooltip-icon hdn-drill-down"
                appTooltip
                [dataContext]="''"
                [IsButtonPanel]="false"
                IsAnswerToolTip="true"
                IsHiddenQToolTip="true"
                tabindex="0"
              ></span>
              <span
                *ngIf="
                  !question.piping &&
                  (question?.qtitle != '' || isDisplayQno || question?.mandatory)
                "
                [ngClass]="{
                  'question-text': question?.isOverAllStyleApplied,
                  'question-text-nb': !question?.isOverAllStyleApplied,
                  'no-Qno': !isDisplayQno,
                  'drill-subq-read-only': question?.population_type == 3
                }"
                id="lbltitle_L{{ question?.UniqueNumber }}"
              >
                <span
                  *ngIf="isDisplayQno"
                  class="question-no"
                  style="display: inline-block"
                  [innerHTML]="question?.subQnoinChar | headerFooterHtml"
                ></span>
                <span [innerHTML]="question?.qtitle | headerFooterHtml"></span>
                <span
                  *ngIf="question.QuestionTip"
                  class="tooltip_icon"
                  appTooltip
                  [dataContext]="question?.QuestionTip"
                  [IsButtonPanel]="false"
                  [qid]="question?.UniqueNumber"
                  tabindex="0"
                ></span>
                <span class="imgPostPrepop" 
            *ngIf="isEditPostPop == true && (question?.population_type== 4 || question?.population_type == 5)"></span>
              </span>
            </div>
          </td>

          <td *ngIf="question.isDrillSearchEnable; else NormalDrillDown">
            <div *ngIf="question.population_type != 3; else PreReadPopulation">
              <div *ngIf="GetSelectedAnswer(i, question) != null">
                <div
                  class="custom-select-wrapper drill-down-search"
                  [ngClass]="question.selectAnsValue > 0 ? 'no-search-icon' : ''"
                  id="drill_{{ question.UniqueNumber }}"
                >
                  <div _ngcontent-xlf-c17="" class="arr" (click)="showDDList($event)">
                    <div _ngcontent-xlf-c17="" class="arr-symbol"></div>
                  </div>
                  <input
                    type="text"
                    class="drill-down-input"
                    placeholder="{{ surveyMessages.Search }}"
                    (keydown)="filterDDSearch($event)"
                    (click)="filterDDSearch($event)"
                    (change)="filterDDSearch($event)"
                    (blur)="setDDListItem($event, question, i)"
                    (focus)="setPrevValue($event)"
                    [(ngModel)]="question.AnswerText"
                    aria-label="Search"
                    [attr.aria-required]="
                      (question?.mandatory && (isMandatoryUpfront || question?.isMandatoryStar)) ||
                      (question?.mandatory && isFormSubmit && question.isMandatoryInvalid)
                    "
                    (keydown.esc)="closeDDList($event)"
                    (keydown.alt.arrowdown)="showDDList($event)"
                  />
                  <div
                    class="drill-down-list"
                    style="max-height: 300px; overflow: auto; z-index: 1000"
                  >
                    <div
                      class="drill-down-list-item"
                      *ngFor="let answers of GetSelectedAnswer(i, question)"
                      [attr.list-value]="answers.value_id"
                      (mousedown)="selectDDListItem($event, question, i)"
                      [attr.ogListValue]="answers.value_text"
                    >
                      {{ answers.value_text }}
                    </div>
                  </div>
                  <select
                    (change)="SelectedValue($event.target.value, question, i)"
                    [(ngModel)]="question.selectAnsValue"
                    aria-label="select"
                    tabindex="-1"
                  >
                    <option [value]="0" selected [innerHTML]="DropDown | headerFooterHtml"></option>
                    <option
                      *ngFor="let answers of GetSelectedAnswer(i, question)"
                      [hidden]="answers?.isHide"
                      [value]="answers.value_id"
                    >
                      <span [innerHTML]="answers.value_text | headerFooterHtml"></span>
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <ng-template #PreReadPopulation>
              <div *ngIf="GetSelectedAnswer(i, question) != null">
                <span class="answer-text">{{ question.AnswerText }}</span>
              </div>
            </ng-template>
          </td>
          <ng-template #NormalDrillDown>
            <td>
              <div *ngIf="question.population_type != 3; else NormalPreReadPopulation">
                <div *ngIf="GetSelectedAnswer(i, question) != null">
                  <div class="custom-select-wrapper">
                    <div _ngcontent-xlf-c17="" class="arr">
                      <div _ngcontent-xlf-c17="" class="arr-symbol"></div>
                    </div>
                    <select
                      (change)="SelectedValue($event.target.value, question, i)"
                      [(ngModel)]="question.selectAnsValue"
                      aria-label="select"
                      [attr.aria-required]="
                        (question?.mandatory &&
                          (isMandatoryUpfront || question?.isMandatoryStar)) ||
                        (question?.mandatory && isFormSubmit && question.isMandatoryInvalid)
                      "
                    >
                      <option
                        [value]="0"
                        selected
                        [innerHTML]="DropDown | headerFooterHtml"
                      ></option>
                      <option
                        *ngFor="let answers of GetSelectedAnswer(i, question)"
                        [hidden]="answers?.isHide"
                        [value]="answers.value_id"
                      >
                        <span [innerHTML]="answers.value_text | headerFooterHtml"></span>
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <ng-template #NormalPreReadPopulation>
                <div *ngIf="GetSelectedAnswer(i, question) != null">
                  <span class="answer-text">{{ question.AnswerText }}</span>
                </div>
              </ng-template>
            </td>
          </ng-template>
        </tr>
      </table>

      <div class="drill-down-wrapper" *ngIf="isMobile">
        <div
          *ngFor="let question of questions; let i = index"
          [hidden]="question.population_type == 2 && !isShowHiddenQN"
          class="drill-down-subqtn"
        >
          <div *ngIf="question.isDrillSearchEnable; else NormalDrillDown">
            <div
              *ngIf="GetSelectedAnswer(i, question) != null"
              [ngClass]="
                (question?.mandatory && (isMandatoryUpfront || question?.isMandatoryStar)) ||
                (question?.mandatory && isFormSubmit && question.isMandatoryInvalid)
                  ? 'isMandatory'
                  : ''
              "
            >
              <div
                *ngIf="question.piping"
                [ngClass]="{
                  'question-text': question?.isOverAllStyleApplied,
                  'question-text-nb': !question?.isOverAllStyleApplied,
                  'no-Qno': !isDisplayQno
                }"
                id="lbltitle_L{{ question?.UniqueNumber }}"
              >
                <span [innerHTML]="question?.pipingQuationTitle | headerFooterHtml"></span>
                <span
                  *ngIf="question.QuestionTip"
                  class="tooltip_icon"
                  appTooltip
                  [dataContext]="question?.QuestionTip"
                  [IsButtonPanel]="false"
                  [qid]="question?.UniqueNumber"
                  tabindex="0"
                ></span>
                 <span class="imgPostPrepop" 
            *ngIf="isEditPostPop == true && (question?.population_type== 4 || question?.population_type == 5)"></span>
              </div>

              <div
                *ngIf="!question.piping"
                [ngClass]="{
                  'question-text': question?.isOverAllStyleApplied,
                  'question-text-nb': !question?.isOverAllStyleApplied,
                  'no-Qno': !isDisplayQno
                }"
                id="lbltitle_L{{ question?.UniqueNumber }}"
              >
                <span
                  *ngIf="
                    isPreview &&
                    (questions[i].population_type == 2 || questions[i].population_type == 5) &&
                    questions[i] == question
                  "
                  class="hidden-question-tooltip-icon hdn-drill-down"
                  appTooltip
                  [dataContext]="''"
                  [IsButtonPanel]="false"
                  IsAnswerToolTip="true"
                  IsHiddenQToolTip="true"
                  tabindex="0"
                ></span>
                <span
                  *ngIf="isDisplayQno"
                  class="question-no"
                  [innerHTML]="question?.subQnoinChar | headerFooterHtml"
                ></span>
                <span [innerHTML]="question?.qtitle | headerFooterHtml"></span>
                <span
                  *ngIf="question.QuestionTip"
                  class="tooltip_icon"
                  appTooltip
                  [dataContext]="question?.QuestionTip"
                  [IsButtonPanel]="false"
                  [qid]="question?.UniqueNumber"
                  tabindex="0"
                ></span>
                <span class="imgPostPrepop" 
            *ngIf="isEditPostPop == true && (question?.population_type== 4 || question?.population_type == 5)"></span>
              </div>

              <span
                *ngIf="
                  ((question?.mandatory && (isMandatoryUpfront || question?.isMandatoryStar)) ||
                    (question?.mandatory && isFormSubmit && question.isMandatoryInvalid)) &&
                  isMobile
                "
                class="screen-reader-only"
                >This Question is Required</span
              >
              <div *ngIf="question.population_type != 3; else MbPreReadPopulation">
                <div
                  class="custom-select-wrapper drill-down-search"
                  [ngClass]="question.selectAnsValue > 0 ? 'no-search-icon' : ''"
                  id="drill_{{ question.UniqueNumber }}"
                >
                  <div _ngcontent-xlf-c17="" class="arr" (click)="showDDList($event)">
                    <div _ngcontent-xlf-c17="" class="arr-symbol"></div>
                  </div>
                  <input
                    type="text"
                    class="drill-down-input"
                    placeholder="{{ surveyMessages.Search }}"
                    (keydown)="filterDDSearch($event)"
                    role="combobox"
                    (change)="filterDDSearch($event)"
                    (blur)="setDDListItem($event, question, i)"
                    (focus)="setPrevValue($event)"
                    [(ngModel)]="question.AnswerText"
                    aria-label="Search"
                    [attr.aria-required]="
                      (question?.mandatory && (isMandatoryUpfront || question?.isMandatoryStar)) ||
                      (question?.mandatory && isFormSubmit && question.isMandatoryInvalid)
                    "
                  />
                  <div
                    class="drill-down-list"
                    style="max-height: 300px; width: 100%; overflow: auto; z-index: 1000"
                    role="listbox"
                  >
                    <div
                      class="drill-down-list-item"
                      role="option"
                      *ngFor="let answers of GetSelectedAnswer(i, question)"
                      [attr.list-value]="answers.value_id"
                      (mousedown)="selectDDListItem($event, question, i)"
                      [attr.ogListValue]="answers.value_text"
                    >
                      {{ answers.value_text }}
                    </div>
                  </div>
                  <select
                    (change)="SelectedValue($event.target.value, question, i)"
                    [(ngModel)]="question.selectAnsValue"
                    aria-label="select"
                    tabindex="-1"
                  >
                    <option [value]="0" selected [innerHTML]="DropDown | headerFooterHtml"></option>
                    <option
                      *ngFor="let answers of GetSelectedAnswer(i, question)"
                      [hidden]="answers?.isHide"
                      [value]="answers.value_id"
                    >
                      <span [innerHTML]="answers.value_text | headerFooterHtml"></span>
                    </option>
                  </select>
                </div>
              </div>
              <ng-template #MbPreReadPopulation>
                <div class="drill-mob-read-only" *ngIf="GetSelectedAnswer(i, question) != null">
                  <span class="answer-text">{{ question.AnswerText }}</span>
                </div>
              </ng-template>
            </div>
          </div>
          <ng-template #NormalDrillDown>
            <div
              *ngIf="GetSelectedAnswer(i, question) != null"
              [ngClass]="
                (question?.mandatory && (isMandatoryUpfront || question?.isMandatoryStar)) ||
                (question?.mandatory && isFormSubmit && question.isMandatoryInvalid)
                  ? 'isMandatory'
                  : ''
              "
            >
              <div
                *ngIf="question.piping"
                [ngClass]="{
                  'question-text': question?.isOverAllStyleApplied,
                  'question-text-nb': !question?.isOverAllStyleApplied,
                  'no-Qno': !isDisplayQno
                }"
                id="lbltitle_L{{ question?.UniqueNumber }}"
              >
                <span [innerHTML]="question?.pipingQuationTitle | headerFooterHtml"></span>
                <span
                  *ngIf="question.QuestionTip"
                  class="tooltip_icon"
                  appTooltip
                  [dataContext]="question?.QuestionTip"
                  [IsButtonPanel]="false"
                  [qid]="question?.UniqueNumber"
                  tabindex="0"
                ></span>
                                 <span class="imgPostPrepop" 
            *ngIf="isEditPostPop == true && (question?.population_type== 4 || question?.population_type == 5)"></span>
              </div>

              <div
                *ngIf="!question.piping"
                [ngClass]="{
                  'question-text': question?.isOverAllStyleApplied,
                  'question-text-nb': !question?.isOverAllStyleApplied,
                  'no-Qno': !isDisplayQno
                }"
                id="lbltitle_L{{ question?.UniqueNumber }}"
              >
                <span
                  *ngIf="
                    isPreview &&
                    (questions[0].population_type == 2 || questions[0].population_type == 5) &&
                    questions[0] == question
                  "
                  class="hidden-question-tooltip-icon hdn-drill-down"
                  appTooltip
                  [dataContext]="''"
                  [IsButtonPanel]="false"
                  IsAnswerToolTip="true"
                  IsHiddenQToolTip="true"
                  tabindex="0"
                ></span>
                <span
                  *ngIf="isDisplayQno"
                  class="question-no"
                  [innerHTML]="question?.subQnoinChar | headerFooterHtml"
                ></span>
                <span [innerHTML]="question?.qtitle | headerFooterHtml"></span>
                <span
                  *ngIf="question.QuestionTip"
                  class="tooltip_icon"
                  appTooltip
                  [dataContext]="question?.QuestionTip"
                  [IsButtonPanel]="false"
                  [qid]="question?.UniqueNumber"
                  tabindex="0"
                ></span>
                <span class="imgPostPrepop" 
            *ngIf="isEditPostPop == true && (question?.population_type== 4 || question?.population_type == 5)"></span>
              </div>

              <span
                *ngIf="
                  ((question?.mandatory && (isMandatoryUpfront || question?.isMandatoryStar)) ||
                    (question?.mandatory && isFormSubmit && question.isMandatoryInvalid)) &&
                  isMobile
                "
                class="screen-reader-only"
                >This Question is Required</span
              >
              <div *ngIf="question.population_type != 3; else MbNormalPreReadPopulation">
                <div class="custom-select-wrapper" style="margin-top: 10px">
                  <div _ngcontent-xlf-c17="" class="arr">
                    <div _ngcontent-xlf-c17="" class="arr-symbol"></div>
                  </div>
                  <select
                    (change)="SelectedValue($event.target.value, question, i)"
                    [(ngModel)]="question.selectAnsValue"
                    aria-label="select"
                    [attr.aria-required]="
                      (question?.mandatory && (isMandatoryUpfront || question?.isMandatoryStar)) ||
                      (question?.mandatory && isFormSubmit && question.isMandatoryInvalid)
                    "
                  >
                    <option [value]="0" selected [innerHTML]="DropDown | headerFooterHtml"></option>
                    <option
                      *ngFor="let answers of GetSelectedAnswer(i, question)"
                      [hidden]="answers?.isHide"
                      [value]="answers.value_id"
                    >
                      <span [innerHTML]="answers.value_text | headerFooterHtml"></span>
                    </option>
                  </select>
                </div>
              </div>
              <ng-template #MbNormalPreReadPopulation>
                <div class="drill-mob-read-only" *ngIf="GetSelectedAnswer(i, question) != null">
                  <span class="answer-text">{{ question.AnswerText }}</span>
                </div>
              </ng-template>
            </div>
          </ng-template>
        </div>
      </div>
      <ng-container *ngIf="isNewParticipation && (surveyFormat == 1 || surveyFormat == 2)">
        <div class="ques-response-btn-div" *ngIf="isNewParticipationButton">
          <!-- <input type="button" value="{{newParticipationBtnText}}" class="ques-response-btn"
            (click)="gotoNextQuestion(questions[0],$event.target)" /> -->
          <button
            *ngIf="isAnsChange"
            type="button"
            class="ques-response-btn"
            (keyup.Space)="gotoNextQuestionKeyboard(questions, $event)"
            (click)="gotoNextQuestion(questions[0], $event.target)"
          >
            {{ newParticipationBtnText }}
          </button>
        </div>
      </ng-container>
    </div>
  </fieldset>
</div>
